import { ReactNode } from 'react';

import { Modal } from '@willow/shared-web/bootstrap';

import './Modal.scss';

interface Props {
  children: ReactNode;
  showModal: boolean;
  onClose: () => void;
}

export const WillowModal = ({ children, showModal, onClose }: Props) => (
  <Modal show={showModal} onHide={onClose} className="willow-modal">
    {children}
  </Modal>
);
